import { action, makeObservable, observable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { LinkAddEditForm } from '../forms';
import { formInvalidate, notificationError } from 'core/utils';
import LinksStore from './LinksStore';

class LinkAddEditViewStore extends BaseViewStore {
	@observable isEdit = false;
	@observable id = null;

	form = new LinkAddEditForm({
		onSuccess: async () => this.save(),
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.linksStore = new LinksStore(rootStore);
		this.onSuccessCallback = modalParams.data.onSuccess;

		if (modalParams.data.id) {
			this.isEdit = true;
			this.id = modalParams.data.id;
			this.form.update({
				description: modalParams.data.description,
				url: modalParams.data.url,
			});
		}
	}

	@action.bound
	async save() {
		this.suspend();
		try {
			const values = this.form.values();
			if (this.isEdit) {
				await this.linksStore.updateLink({
					id: this.id,
					...values,
				});
				this.rootStore.notificationStore.success(['Link updated successfully']);
			} else {
				await this.linksStore.createLink(values);
				this.rootStore.notificationStore.success(['Link created successfully']);
			}
			this.modalParams.close();
			if (this.onSuccessCallback) {
				this.onSuccessCallback();
			}
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	}

	@action.bound
	cancel() {
		this.modalParams.close();
	}
}

export default LinkAddEditViewStore;
